export default "__VITE_ASSET__D0tZjEj6__"